import React from "react";
import FormSectionHeading from "../Form/FormSectionHeading";
import Dropdown from "../Form/Dropdown";
import MultiSelectDropdown from "../Form/MultiSelectDropDown";
import { cities } from "../../constants/commonConstants";
import { FaPlus } from "react-icons/fa";
import { CiCircleRemove } from "react-icons/ci";

const ServingAreasSection = ({
  setServingAreas,
  servingAreas,
  setServingAreasErrors,
  servingAreasErrors,
  servingAreasTouched,
  setservingAreasTouched,
}) => {
  // FUNCTION: Add City
  const handleAddCity = () => {
    let hasErrors = false;

    // Validate all previous cities
    const updatedErrors = servingAreas?.map((city, i) => {
      let cityError = "";
      let subcityError = "";

      if (!city.city) {
        cityError = "City is required";
        hasErrors = true;
      }

      if (city.subcities.length === 0) {
        subcityError = "At least one subcity is required";
        hasErrors = true;
      }

      return {
        ...servingAreasErrors[i],
        city: cityError,
        subcities: subcityError,
      };
    });

    // If there are errors, update state and prevent adding a new city
    if (hasErrors) {
      setServingAreasErrors(updatedErrors);
      setservingAreasTouched((prev) =>
        prev.map((touched, i) => ({
          ...touched,
          city: !servingAreas[i]?.city,
          subcities: servingAreas[i]?.subcities.length === 0,
        }))
      );
      return;
    }

    // If validation passes, add a new city
    setServingAreas((prev) => [
      ...prev,
      { city: null, cityName: "", subcities: [] },
    ]);

    setServingAreasErrors((prev) => [...prev, { city: "", subcities: "" }]);

    setservingAreasTouched((prev) => [...prev, { city: false, subcities: [] }]);
  };

  // FUNCTION: Handle City Change
  const handleCityChange = (cityIndex, selectedCity) => {
    setServingAreas((prev) =>
      prev.map((item, i) =>
        i === cityIndex
          ? {
              ...item,
              city: selectedCity,
              cityName: selectedCity?.name,
              subcities: [],
            }
          : item
      )
    );

    // Clear errors when valid selection is made
    setServingAreasErrors((prev) =>
      prev.map((error, i) => (i === cityIndex ? { ...error, city: "" } : error))
    );
  };

  // FUNCTION: Handle Sub City Change
  const handleSubCityChange = (cityIndex, selectedSubCity) => {
    setServingAreas((prev) =>
      prev.map((item, i) =>
        i === cityIndex
          ? {
              ...item,
              subcities: selectedSubCity,
            }
          : item
      )
    );

    // Clear errors when subcities are selected
    setServingAreasErrors((prev) =>
      prev.map((error, i) =>
        i === cityIndex ? { ...error, subcities: "" } : error
      )
    );
  };

  // FUNCTION: clear city errors
  const handleClearErrors = (cityIndex) => {
    setServingAreasErrors((prev) =>
      prev.map((error, i) => (i === cityIndex ? { ...error, city: "" } : error))
    );

    setservingAreasTouched((prev) =>
      prev.map((touched, i) =>
        i === cityIndex ? { ...touched, city: false } : touched
      )
    );
  };

  // FUNCTION: Clear Sub City Errors
  const handleClearSubCityErrors = (cityIndex) => {
    setServingAreasErrors((prev) =>
      prev.map((error, i) =>
        i === cityIndex ? { ...error, subcities: "" } : error
      )
    );

    setservingAreasTouched((prev) =>
      prev.map((touched, i) =>
        i === cityIndex ? { ...touched, subcities: false } : touched
      )
    );
  };

  // Filter out cities that are already selected
  const filteredCities = cities.filter(
    (city) =>
      !servingAreas.find((servingArea) => servingArea.city?._id === city._id)
  );

  const handleRemoveCity = (cityIndex) => {
    // Remove city from serving areas - if there is only one city, don't remove it, and clear the city and subcity
    if (servingAreas.length === 1) return;

    setServingAreas((prev) => prev.filter((city, i) => i !== cityIndex));
    setServingAreasErrors((prev) => prev.filter((error, i) => i !== cityIndex));
    setservingAreasTouched((prev) =>
      prev.filter((touched, i) => i !== cityIndex)
    );
  };

  return (
    <div>
      <FormSectionHeading title="Serving Areas" index={4} />
      <div className="mt-6 relative h-fit">
        <div className="absolute left-1 w-[0.9375rem] h-[0.9375rem] bg-[#FBC948] rounded-full" />
        <div className=" ml-7 lg:ml-12">
          {servingAreas.map((servingAreaDetail, cityIndex) => (
            <div key={cityIndex} className="mb-4 ">
              <div className=" flex flex-wrap gap-[1.0625rem] relative">
                <Dropdown
                  placeholder="Select City"
                  options={filteredCities}
                  defaultOption={servingAreaDetail?.city}
                  onSelect={(selectedCity) =>
                    handleCityChange(cityIndex, selectedCity, "city")
                  }
                  onBlur={() => {}}
                  error={
                    servingAreasTouched[cityIndex]?.city &&
                    servingAreasErrors[cityIndex]?.city
                  }
                  onFocus={() => handleClearErrors(cityIndex)}
                  isSearchable={true}
                  label="City"
                  displayKey="name"
                  idKey="_id"
                  labelStyle="text-content"
                  buttonClassName="rounded-lg"
                  allowFillColor={false}
                  isRequired={true}
                  outerContainerStyle="w-full lg:w-[33.125rem]"
                  dropdownClassName=" font-inter text-dark text-sm"
                />
                <MultiSelectDropdown
                  options={servingAreaDetail?.city?.subcities}
                  defaultSelected={servingAreaDetail?.subcities}
                  onSelect={(selectedSubCity) =>
                    handleSubCityChange(cityIndex, selectedSubCity)
                  }
                  label="Sub City"
                  placeholder="Select Sub City"
                  isRequired={true}
                  onFocus={() => handleClearSubCityErrors(cityIndex)}
                  error={
                    servingAreasTouched[cityIndex]?.subcities &&
                    servingAreasErrors[cityIndex]?.subcities
                  }
                  isSearchable={true}
                  idKey="_id"
                  displayKey="name"
                  labelStyle="text-content"
                  outerContainerStyle="w-full lg:w-[33.125rem]"
                />
                {servingAreas.length > 1 && (
                  <button
                    className=" absolute right-0 -top-1 lg:relative text-[#C8CAD8] hover:text-red-500 transition duration-150 ease-in-out"
                    onClick={() => handleRemoveCity(cityIndex)}
                  >
                    <CiCircleRemove size={28} />
                  </button>
                )}
              </div>
            </div>
          ))}

          {servingAreas[0]?.city && (
            <button
              type="button"
              onClick={handleAddCity}
              className="flex items-center gap-1 font-inter text-dark text-sm font-semibold"
            >
              <FaPlus />
              Add City
            </button>
          )}
        </div>
        <div className="absolute left-1 bottom-0 w-[0.9375rem] h-[0.9375rem] bg-[#FBC948] rounded-full" />
        <div className="absolute left-[0.625rem] top-0 w-[0.125rem] h-full bg-[#FBC948] bg-opacity-[24%]" />
      </div>
    </div>
  );
};

export default ServingAreasSection;
